<section
  class="section section-lg section-main-bunner section-main-bunner-filter text-center"
>
  <div
    class="main-bunner-img"
    style="
      background: url(&quot;assets/images/hamburguesa2.webp&quot;);
      background-size: cover;
      background-position-x: center;
    "
  ></div>

  <div class="main-bunner-inner">
    <div class="container">
      <div class="box-default">
        <img
          src="assets/images/Sachacabrona-removebg-preview.png"
          alt="Logo Hamburguesa"
          class="hero-logo"
        />

        <h1 class="box-default-title">Sachacabrona</h1>
        <div class="box-default-decor"></div>
        <p class="big box-default-text">
          La mejor hamburguesa del país de nuestro local a tu mesa
        </p>

        <button mat-button class="btn-menu" (click)="irAlMenu()">
          IR AL MENU
        </button>
      </div>
    </div>
  </div>
</section>

<!-- <app-featured-offers></app-featured-offers> -->

<app-recent-news></app-recent-news>
